import { useQuery } from "@tanstack/react-query";

import { ConverterType } from "../types/ConverterType";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";

const getConverterTypes = async (): Promise<ConverterType[]> => {
  const { data } = await fetcher.get<ConverterType[]>(
    `${API.GESLUB}/converter-type`,
  );
  return data;
};

export const useGetConverterTypes = () => {
  const query = useQuery<ConverterType[], Error>({
    queryKey: ["converter-types"],
    queryFn: getConverterTypes,
  });
  const isPending = query.isLoading;

  return {
    ...query,
    data: query.data ?? [],
    isPending,
  };
};
